import { render, staticRenderFns } from "./BtnInserirItemContrato.vue?vue&type=template&id=ef2c8c28"
import script from "./BtnInserirItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnInserirItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports